import React from 'react';
import Text from 'fe-design-base/atoms/Text';
import Link from 'fe-design-base/molecules/Link/Link';

import { toI18n } from 'util/i18n';

import Footer from '../components/Footer';
import Header from '../components/Header';
import PastDueDialogBox from '../components/PastDueDialogBox';

import { EnforcedLocationViewProps } from './types';

export const EnforcedLocationView = ({
  onClickPrimary,
  primaryCtaText,
  primaryUxElement,
  previousTierName,
}: EnforcedLocationViewProps) => (
  <PastDueDialogBox>
    <Header
      iconName="Warning"
      iconColor="orange300"
      titleI18n="past_due_subscription.dialog.enforced_location.title"
    />
    <Text
      variant="body"
      color="mono900"
      i18n="past_due_subscription.dialog.enforced_location.description_pre_text"
      i18nProps={{
        previousPlanName: previousTierName,
      }}
      asHTML
    >
      &nbsp;
      <Link href="/help" target="_blank">
        {toI18n(
          'past_due_subscription.dialog.enforced_location.description_link_text'
        )}
      </Link>
      &nbsp;
      {toI18n(
        'past_due_subscription.dialog.enforced_location.description_post_text'
      )}
    </Text>
    <Footer
      onClickPrimary={onClickPrimary}
      primaryCtaText={primaryCtaText}
      primaryUxElement={primaryUxElement}
    />
  </PastDueDialogBox>
);

export default EnforcedLocationView;
